import React from "react";
import "@google/model-viewer/dist/model-viewer";

const AssetViewer = ({ theeDAssetFile }) => {
  const modelRef = React.useRef();
  return (
    <model-viewer
      style={{ width: "100%", height: "100%", backgroundColor: "#eee" }}
      src={theeDAssetFile}
      alt="A rock"
      shadow-intensity="1"
      camera-controls
      touch-action="pan-y"
      ar
      ar-modes="webxr"
      ref={(ref) => {
        modelRef.current = ref;
      }}
    ></model-viewer>
  );
};

export default AssetViewer;
